import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Player from "@vimeo/player";
import arrow_popup from "../Assets/arrow_popup.gif";

const Masterclass = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [seconds, setSeconds] = useState(0);

  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      const player = new Player(iframeRef.current);

      player.on("timeupdate", (data) => {
        handleProgress(data.seconds);
      });

      return () => {
        player.off("timeupdate");
      };
    }
  }, [iframeRef.current]);

  const handleProgress = (secs) => {
    setSeconds(secs);
  };

  const navigatepage = () => {
    navigate("/Apply");
  };

  return (
    <>
      <Header />
      <section>
        <div className="container">
          <div className="mt-2">
            <h6 className="watchtext">Watch the Video Below</h6>
          </div>
          <h1 className="subsubtitle pt-3 theme_color pb-3">
            (Click the PLAY button to start the Video)
          </h1>
          <div className="row mt-3">
            <div className="col-lg-9 mx-auto ms-auto">
              {/* <ReactPlayer
                url="https://vimeo.com/1051018697"
                className="videoalignment"
                onProgress={(e) => handleProgress(e.playedSeconds)}
              /> */}

              <iframe
                // ref={iframeRef}
                src="https://player.vimeo.com/video/1051018697?badge=0&autopause=0&player_id=0&app_id=58479"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                className="videoalignment"
                title="TiE Chennai Personal Board - VSL"
              ></iframe>
            </div>
          </div>
          <h6 className="webinartext mt-5">
            Schedule a{" "}
            <span className="freecall"> Call with our Expert team </span> <br />
            to become a member of{" "}
            <span className="freecall">TiE Chennai’s Personal Board.</span>
          </h6>

          <h6 className="clickbutton">
            Click the Button below &nbsp;{" "}
            {/* <span className="clickbuttonend">
              (*Button will be enabled at the Middle of the video) and
            </span> */}
            <br />
            {/* <span className="book">Book a Call with Our Experts.</span> */}
          </h6>

          <div className="alignment d-flex justify-content-center   py-4">
            <button
              className="thank_button d-flex align-items-center justify-content-center applybutton"
              // style={parseFloat(seconds) < 80 ? { display: "none" } : {}}
              onClick={() => {
                navigatepage();
                window.fbq("track", "Lead");
              }}
            >
              <img
                src={arrow_popup}
                alt="Social Social"
                className="gif_image me-3"
              />
              <span className="mt-1"> SCHEDULE A CALL HERE</span>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Masterclass;
